// extracted by mini-css-extract-plugin
export default {"compareButton_checkboxes":"webpack-concepts-Extraction-Blocks-Checkboxes-control-CheckboxesComparisonRow-CheckboxesComparisonRow-module__compareButton_checkboxes"};